import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Resolves the value of a sibling country select for a country-aware validator.
 *
 * Formly hands every `validators.validation` function the field as its second argument, so `field.model` is the
 * primary source - the SAME mechanism the `props.*` expressions in `identity-field-expressions.ts` use. Reading it
 * two different ways is how the two drift apart.
 *
 * `control.parent` is kept as a fallback so the validators still work when called directly (plain reactive forms,
 * and the unit tests that build a bare `FormGroup`). It resolves today only because `formRow` produces a KEYLESS
 * field group, which leaves the siblings in one flat `FormGroup`; give a row a key and the fallback silently
 * returns undefined, which is exactly why `field.model` is tried first.
 */
export const siblingCountryCode = (
  control: AbstractControl,
  field: FormlyFieldConfig | undefined,
  countryCodeKey: string,
): string | undefined =>
  (field?.model?.[countryCodeKey] as string | undefined) ?? (control.parent?.get(countryCodeKey)?.value as string | undefined);
